import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Layout } from "../components/Layout";
import { Logo } from "../components/Logo";
import * as apiClient from "../api";

export default function Activate() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);
  const { data, isLoading, isError } = useQuery({ queryKey: ["invite", token], queryFn: () => apiClient.checkInvite(token), retry: false });

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("La password deve avere almeno 8 caratteri");
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setSaving(true);
    try {
      await apiClient.activateOperator(token, pw);
      toast.success("Account attivato! Ora puoi accedere.");
      navigate("/accedi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore di attivazione");
    } finally { setSaving(false); }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-20" data-testid="activate-page">
        <Logo />
        {isLoading ? <p className="mt-8 text-slate-400">Verifica invito...</p> : isError ? (
          <div className="mt-8 text-center">
            <h1 className="text-2xl font-heading font-semibold text-slate-900">Invito non valido</h1>
            <p className="mt-2 text-slate-500">Questo invito è scaduto o è già stato utilizzato. Contatta Cristalda.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <h1 className="text-2xl font-heading font-semibold text-slate-900">Attiva il tuo account</h1>
            <p className="text-slate-500 text-sm">Benvenuto{data?.operator_name ? `, ${data.operator_name}` : ""}. Imposta la tua password per accedere come operatore ({data?.email}).</p>
            <input type="password" data-testid="activate-password" placeholder="Nuova password (min 8)" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full rounded-lg border border-slate-200 px-4 py-3 text-sm" />
            <input type="password" data-testid="activate-password2" placeholder="Conferma password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full rounded-lg border border-slate-200 px-4 py-3 text-sm" />
            <button type="submit" disabled={saving} data-testid="activate-submit" className="w-full rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-primary/90 transition-colors">
              {saving ? "Attivazione..." : "Attiva account"}
            </button>
          </form>
        )}
      </div>
    </Layout>
  );
}
